export default __webpack_public_path__ + "static/media/black-bg.d39c103f.jpg";